// import React from 'react'

import { Button, message } from 'antd';
import NachWrapper from '../components/NachWrapper';
import { useCallback, useState } from 'react';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import { ifscValidator } from '../utils/ifscValidator';

function RazorPayTest() {
  const [Razorpay] = useRazorpay();
  const [orderInput, setOrderInput] = useState({ id: '', cust_id: '' });
  const [ifsc, setIfsc] = useState('');
  const handlePayment = useCallback(
    (order: { id: string; cust_id: string }) => {
      const options: RazorpayOptions = {
        key: import.meta.env.VITE_RAZORPAY_KEY,
        order_id: order.id,
        customer_id: order.cust_id,
        recurring: true,
        currency: 'INR',
        amount: '100',
        name: 'Avanse Corp',
        handler: function (response) {
          alert(response.razorpay_payment_id);
          alert(response.razorpay_order_id);
          alert(response.razorpay_signature);
        },
        notes: {
          'note_key 1': 'Beam me up Scotty',
          'note_key 2': 'Tea. Earl Gray. Hot.',
        },
        theme: {
          color: '#F37254',
        },
      };

      const rzpay = new Razorpay(options);
      rzpay.open();
    },
    [Razorpay]
  );
  const handleSubmit = () => {
    if (!orderInput.cust_id || !orderInput.id) {
      message.error('Please fill Customer Id and Order Id');
      return;
    }
    handlePayment(orderInput);
  };

  const handleIfsc = () => {
    ifscValidator({ ifsc: ifsc }).then((res) => {
      console.log(res);
    });
  };

  return (
    <NachWrapper title="RazorPay Test">
      <div
        style={{
          display: 'flex',
          backgroundColor: 'white',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <div style={{ display: 'flex', gap: '10px' }}>
          <label htmlFor="order">
            Enter Order Id:{' '}
            <input
              type="text"
              onChange={(e) => {
                setOrderInput({ ...orderInput, id: e.target.value });
              }}
            />
          </label>
          <label htmlFor="cust">
            {' '}
            Enter Customer Id:{' '}
            <input
              type="text"
              onChange={(e) => {
                setOrderInput({ ...orderInput, cust_id: e.target.value });
              }}
            />{' '}
          </label>
        </div>
        <Button onClick={handleSubmit} type="primary">
          Pay
        </Button>

        <div style={{ marginTop: '40px' }}>
          <input
            onChange={(e) => {
              setIfsc(e.target.value);
            }}
            type="text"
          />
          <br />
          <Button type="primary" onClick={handleIfsc}>
            Ifsc Validate
          </Button>
        </div>
      </div>
    </NachWrapper>
  );
}

export default RazorPayTest;
